module.exports = __webpack_public_path__ + "img/87.8b19ee3b.jpg";